import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const CTASection = () => {
  return (
    <section className="relative overflow-hidden bg-[#1E40AF]" data-testid="cta-section">
      <div className="absolute inset-0 bg-grid-dark opacity-30" />
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-[#2563EB] blur-[120px] opacity-50" />
      <div className="absolute -left-24 -bottom-24 w-96 h-96 rounded-full bg-[#0F172A] blur-[120px] opacity-40" />
      <div className="relative max-w-[1100px] mx-auto px-5 sm:px-8 py-24 sm:py-28 text-center">
        <Reveal>
          <p className="text-blue-200 text-xs font-semibold tracking-[0.25em] uppercase mb-5">Start Your Certification</p>
          <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight max-w-4xl mx-auto">
            Ready to Accelerate Your Certification Journey?
          </h2>
          <p className="mt-6 text-blue-100/90 text-lg max-w-2xl mx-auto">
            Speak with our regulatory experts and get a clear, actionable roadmap to compliant market entry.
          </p>
          <Link
            to="/book-consultation"
            data-testid="cta-book-button"
            className="mt-10 inline-flex items-center gap-2 rounded-full bg-white text-[#1E40AF] font-semibold px-8 py-4 text-base hover:bg-blue-50 transition-colors shadow-lg shadow-blue-900/20 group"
          >
            Book a Consultation
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
